export { default } from './modules/RelativeTimeFormat.js'